export default "__VITE_ASSET__DMnb26af__"